import i18n from "i18next";

import { messages } from "./languages";

i18n.init({
	debug: false,
	defaultNS: ["translations"],
	lng: "it",
	fallbackLng: "it",
	ns: ["translations"],
	resources: messages,
});

export { i18n };
